var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"more":""}},[_c('div',{attrs:{"more-inner":""}},[_c('div',{attrs:{"more-padding":""}},[_c('a',[_c('s',[_vm._v("View More")]),_c('Icon',{attrs:{"name":"more"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }